module.exports = __webpack_public_path__ + "img/tv.90306c33.jpg";